import React from 'react';
import Tooltip from '../../../../../common/StyledToolTip';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  headerContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '10px',
    marginBottom: 4
  },
  headerIconStyles: {
    cursor: 'pointer',
    color: theme.iconColor,
    fontSize: theme.headerTextFontSize
  },
  headerIconDisabled: {
    color: theme.disabledColor,
    cursor: 'not-allowed'
  }
});

const GridHeader = ({ classes, handleDelete, handleAdd, disableDelete }) => {
  const deleteTooltip = disableDelete ? 'Select rows to delete' : 'Delete';
  return (
    <div className={classes.headerContainer}>
      <span
        className={`${classes.headerIconStyles} ${disableDelete && classes.headerIconDisabled}`}
        onClick={disableDelete ? null : handleDelete}>
        <Tooltip title={deleteTooltip}>
          <DeleteOutlineIcon />
        </Tooltip>
      </span>

      <span className={classes.headerIconStyles} onClick={handleAdd}>
        <Tooltip title="Add">
          <AddRoundedIcon />
        </Tooltip>
      </span>
    </div>
  );
};

export default withStyles(styles)(GridHeader);
